import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

/**
 * HTTP interceptor that proactively refreshes the access token before it expires.
 * If the token is invalid or within the expiry buffer window, it refreshes first,
 * then retries the original request with the new token attached by the JWT module.
 */
export const tokenRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const isAuthEndpoint = req.url.includes('/auth/');

  if (isAuthEndpoint || !authService.hasAccessToken()) {
    return next(req);
  }

  if (authService.checkTokenValidity()) {
    return next(req);
  }

  return authService.refreshToken().pipe(switchMap(() => next(req)));
};
